import gsap, { CSSPlugin } from "gsap";


export default defineNuxtPlugin(nuxtApp => {
   gsap.registerPlugin(CSSPlugin)

   nuxtApp.provide("gsap", gsap);
})